import React from 'react';
import RouterHealthBadge from './RouterHealthBadge';
import { formatTime } from '../lib/routerMonitoringFormatters';

const RouterStatusCard = ({ router }) => {
  if (!router) {
    return (
      <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-4 text-sm text-slate-400">
        Pilih router untuk melihat status.
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-xs uppercase tracking-[0.14em] text-slate-400">Status Router</p>
          <h2 className="text-lg font-semibold text-slate-100">{router.name || '-'}</h2>
        </div>
        <div className="flex flex-wrap items-center justify-end gap-2">
          <RouterHealthBadge isOnline={Boolean(router.isOnline ?? router.is_online)} />
          <span className="inline-flex items-center rounded border border-cyan-400/40 bg-cyan-500/10 px-2 py-0.5 text-[11px] font-semibold text-cyan-200">
            Source: {String(router.sourceAuthority || 'UNKNOWN')}
          </span>
          {router.hasMismatch ? (
            <span className="inline-flex items-center rounded border border-amber-400/50 bg-amber-500/10 px-2 py-0.5 text-[11px] font-semibold text-amber-200">
              Mismatch
            </span>
          ) : null}
        </div>
      </div>
      <div className="mt-3 grid gap-2 text-sm text-slate-300 md:grid-cols-3">
        <p>Identity: <span className="text-cyan-200">{router.identity || '-'}</span></p>
        <p>Version: <span className="text-cyan-200">{router.version || '-'}</span></p>
        <p>Model: <span className="text-cyan-200">{router.model || '-'}</span></p>
        <p>Vendor: <span className="text-cyan-200">{router.vendor || '-'}</span></p>
        <p>Uplink Utama: <span className="text-cyan-200">{router.primaryUplinkInterface || router.primary_uplink_interface || '-'}</span></p>
        <p>Discovery Terakhir: <span className="text-cyan-200">{formatTime(router.lastDiscoveryAt || router.last_discovery_at)}</span></p>
        <p>Monitoring Online: <span className="text-cyan-200">{router.monitoringOnline === null || router.monitoringOnline === undefined ? '-' : (router.monitoringOnline ? 'YA' : 'TIDAK')}</span></p>
        <p>NAS Runtime Online: <span className="text-cyan-200">{router.nasRuntimeOnline === null || router.nasRuntimeOnline === undefined ? '-' : (router.nasRuntimeOnline ? 'YA' : 'TIDAK')}</span></p>
      </div>
    </div>
  );
};

export default RouterStatusCard;
